import { NoPhotography } from '@mui/icons-material'
import { ButtonBase, Card, CircularProgress, Grid, Theme, Typography } from '@mui/material'
import * as controllers from 'controllers'
import { VehicleCheckInPhotoType } from 'dtos'
import { useEffect, useState } from 'react'

interface WarrantyCertPhotoProps {
  complete?: boolean
  disabled?: boolean
  fileName?: string
  label?: string
  onClick?: () => void
  required?: boolean
  type?: 'warranty-cert'
  vehicleGuid?: string
  warning?: boolean
}

export default function WarrantyCertPhotoCard({
  complete,
  disabled,
  label,
  onClick,
  fileName,
  required,
  type,
  vehicleGuid,
  warning
}: WarrantyCertPhotoProps) {
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [photoFileBase64, setPhotoFileBase64] = useState<string>('')
  const [format, setFormat] = useState<string>('')

  const getColor = (theme: Theme): string => {
    if (disabled) {
      return theme.palette.grey[400] // '#b0a8b9'
    } else if (complete) {
      return theme.palette.success.main // '#009c45'
    } else if (warning) {
      return theme.palette.warning.main // '#ffc75f'
    }

    return theme.palette.error.main // '#ff0000'
  }

  const getLabel = () => {
    if (label) {
      return label
    }

    switch (type) {
      case 'warranty-cert':
        return 'Warranty Certificate In Glove Box'
    }
  }

  useEffect(() => {
    if (fileName && vehicleGuid) {
      setFormat(fileName.split('.')[fileName.split('.').length - 1])
      setIsLoading(true)
      controllers
        .getNeedsToBeMovedToStagingPhotoBase64(vehicleGuid, fileName)
        .then(base64 => {
          setPhotoFileBase64(base64)
        })
        .finally(() => {
          setIsLoading(false)
        })
    } else {
      setPhotoFileBase64('')
    }
  }, [fileName, vehicleGuid])

  return (
    <Card
      component={ButtonBase}
      onClick={onClick}
      sx={theme => ({
        backgroundColor: getColor(theme),
        color: '#fff',
        p: 1,
        width: '220px'
      })}
    >
      <Grid container spacing={0} alignItems='center' justifyContent='center'>
        <Grid item sx={{ minHeight: 112.5, maxHeight: 112.5 }}>
          {isLoading && <CircularProgress sx={{ color: '#fff', mt: 5 }} />}
          {!isLoading && photoFileBase64 && (
            <img alt={type} src={`data:image/${format};base64,${photoFileBase64}`} width={200} id={fileName} height={112.5} />
          )}
          {!isLoading && !photoFileBase64 && (
            <>
              <NoPhotography fontSize='large' sx={{ height: 112.5 }} />
            </>
          )}
        </Grid>

        <Grid item xs={12}>
          <Typography align='center'>{getLabel()}</Typography>
        </Grid>
      </Grid>
    </Card>
  )
}
